export type ScdPickerExtendedBaseValue = {
  gid: string;
  firstName: string;
  lastName: string;
  department: string;
};

export type ScdPickerSearchQuery = {
  gid?: string | null;
  firstName?: string | null;
  lastName?: string | null;
};

export type ScdPickerTranslations = {
  dialog: {
    title: string;
    subtitle: string;
    labels: {
      firstName: string;
      lastName: string;
    };
    table: {
      header: {
        name: string;
        gid: string;
        department: string;
        select: string;
      };
      select: string;
    };
    noResults: string;
    cancel: string;
    errors: {
      firstNameRequired: string;
      lastNameRequired: string;
    };
  };
};
